import { SeasonClientModel, SportInfoClientModel } from '@sport1/types/sportData'
import Config from '@/utils/Config'
import getJson from '@/utils/fetch/getJson'

export default async function getSeasonsBySport({
    sportIdentifier,
    sportId,
}: {
    sportIdentifier?: string
    sportId?: string
}): Promise<SeasonClientModel[] | undefined> {
    if (!sportIdentifier || !sportId) {
        return Promise.reject(
            new Error(
                `Error fetching seasons by sport! Any parameter missing > sportIdentifier: ${sportIdentifier}, sportId: ${sportId}`
            )
        )
    }

    const url = `${Config.CMS_API}/v2/de/${sportIdentifier}/sport/${sportId}/info`
    const sportInfo = (await getJson(url)) as SportInfoClientModel

    return sportInfo.seasons
}
